import LoginApp     from "./LoginApp";
import PublicLayout from 'PublicLayout'
import bootstrap    from 'bootstrap';

bootstrap(<LoginApp />, {
  layout: PublicLayout
});
